/* global document:true */
/* global navigator:true */
/* global window:true */
/* global Notification:true */
/* global MessageChannel:true */
/* global btoa:true */
/* eslint no-useless-escape: "off" */
/* eslint no-mixed-operators: "off" */

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Push_API/Using_the_Push_API
 * https://developers.google.com/web/fundamentals/getting-started/codelabs/push-notifications/
 * https://github.com/chrisdavidmills/push-api-demo/
 * https://github.com/web-push-libs/web-push-php
 * https://www.npmjs.com/package/web-push
 */

 import { fetchApiAuth } from '../utils/api';

 const {
     WEB_PUSH_PUBLIC_KEY
 } = require('../constants').default;

 function urlBase64ToUint8Array(base64String) {
     const padding = '='.repeat((4 - base64String.length % 4) % 4);
     const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

     const rawData = window.atob(base64);
     const outputArray = new Uint8Array(rawData.length);

     for (let i = 0; i < rawData.length; ++i) {
         outputArray[i] = rawData.charCodeAt(i);
     }
     return outputArray;
 }

 export function updateStatus(endpoint, key, authSecret, statusType) {
     // console.log('updateStatus', endpoint, key, statusType);

     // send to server!
     const data = {
         statusType,
         end_point: endpoint,
         auth_secret: btoa(String.fromCharCode.apply(null, new Uint8Array(authSecret))),
         notification_key: btoa(String.fromCharCode.apply(null, new Uint8Array(key)))
     };

     // console.log('data to send', data);
     fetchApiAuth({
         method: 'post',
         url: 'notification/register-user-browser',
         body: data
     });
 }

 export function handleChannelMessage(data) {
     console.log('channel message received data', data);
 }

 export function subscribe() {
     navigator.serviceWorker.ready.then((reg) => {
         reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(WEB_PUSH_PUBLIC_KEY) })
             .then((subscription) => {
                // The subscription was successful

                // Update status to subscribe current user on server, and to let
                // other users know this user has subscribed
                 const endpoint = subscription.endpoint;
                 const key = subscription.getKey('p256dh');
                 const authSecret = subscription.getKey('auth');
                 updateStatus(endpoint, key, authSecret, 'subscribe');
             })
             .catch((e) => {
                 if (Notification.permission === 'denied') {
                     // The user denied the notification permission which
                     // means we failed to subscribe and the user will need
                     // to manually change the notification permission to
                     // subscribe to push messages
                     console.log('Permission for Notifications was denied');
                 } else {
                     // A problem occurred with the subscription, this can
                     // often be down to an issue or lack of the gcm_sender_id
                     // and / or gcm_user_visible_only
                     console.log('Unable to subscribe to push.', e);
                 }
             });
     });
 }

 export function unsubscribe() {
     navigator.serviceWorker.ready.then((reg) => {
         // To unsubscribe from push messaging, you need get the
         // subcription object, which you can call unsubscribe() on.
         reg.pushManager.getSubscription().then(
            (subscription) => {
                // Check we have a subscription to unsubscribe
                if (!subscription) {
                    // No subscription object, so set the state
                    // to allow the user to subscribe to push
                    return;
                }
                // Update status to unsubscribe current user from server (remove details)
                // and let other subscribers know they have unsubscribed
                const endpoint = subscription.endpoint;
                const key = subscription.getKey('p256dh');
                const authSecret = subscription.getKey('auth');
                updateStatus(endpoint, key, authSecret, 'unsubscribe');

                // setTimeout used to stop unsubscribe being called before the message
                // has been sent to everyone to tell them that the unsubscription has
                // occurred, including the person unsubscribing. This is a dirty
                // hack, and I'm probably going to hell for writing this.
                setTimeout(() => {
                    // We have a subcription, so call unsubscribe on it
                    subscription.unsubscribe().then((successful) => {
                        console.log('unsubscribe success', successful);
                    }).catch((e) => {
                        // We failed to unsubscribe, this can lead to
                        // an unusual state, so may be best to remove
                        // the subscription id from your data store and
                        // inform the user that you disabled push
                        console.log('Unsubscription error: ', e);
                    });
                }, 3000);
            }).catch((e) => {
                console.log('Error thrown while unsubscribing from push messaging.', e);
            });
     });
 }

 // Once the service worker is registered set the initial state
 export function initialiseState(reg) {
     // Are Notifications supported in the service worker?
     if (!(reg.showNotification)) {
         console.log('Notifications aren\'t supported on service workers.');
         return;
     }

     // Check the current Notification permission.
     // If its denied, it's a permanent block until the
     // user changes the permission
     if (Notification.permission === 'denied') {
         console.log('The user has blocked notifications.');
         return;
     }

     // Check if push messaging is supported
     if (!('PushManager' in window)) {
         console.log('Push messaging isn\'t supported.');
         return;
     }

     // We need the service worker registration to check for a subscription
     navigator.serviceWorker.ready.then((reg) => {
         // Do we already have a push message subscription?
         reg.pushManager.getSubscription()
         .then((subscription) => {
             // Enable any UI which subscribes / unsubscribes from
             // push messages.
             if (!subscription) {
                 console.log('Not yet subscribed to Push, so do it now');
                 // We aren't subscribed to push, so set UI
                 // to allow the user to enable push
                 subscribe();
             }

             // initialize status, which includes setting UI elements for subscribed status
             // and updating Subscribers list via push
             // console.log(subscription.toJSON());
             const endpoint = subscription.endpoint;
             const key = subscription.getKey('p256dh');
             const authSecret = subscription.getKey('auth');
             updateStatus(endpoint, key, authSecret, 'init');
         })
         .catch((err) => {
             console.log('Error during getSubscription()', err);
         });

         // set up a message channel to communicate with the SW
         // when message is received or update happens
         const channel = new MessageChannel();
         channel.port1.onmessage = function (e) {
             handleChannelMessage(e.data);
         };

         // TODO WHO WE NEED THIS
         const mySW = reg.active;
         mySW.postMessage('hello', [channel.port2]);
     });
 }

 export function checkWebPush() {
     if ('serviceWorker' in navigator) {
         console.log('Service Worker and Push is supported');
         navigator.serviceWorker.register('sw.js')
            .then((reg) => {
                // console.log(reg);
                initialiseState(reg);
            })
            .catch((error) => {
                console.error('Service Worker Error', error);
            });
     } else {
         console.log('Service workers aren\'t supported in this browser.');
     }
 }

 export function registerWebPush() {
     Notification.requestPermission();
     checkWebPush();
 }



/** WEBPACK FOOTER **
 ** ./src/core/utils/webPushApi.js
 **/